import { PostSection } from "@/components/blog/PostSection";
import { PostHighlight } from "@/components/blog/PostHighlight";

export function PrediccionesSection() {
  return (
    <PostSection id="predicciones-futuro" title="Predicciones para 2026-2027">
      <p>
        El ecosistema de AI Overviews sigue evolucionando rápidamente. Estas son las tendencias 
        que marcarán los próximos meses.
      </p>

      <h3 id="expansion-cobertura" className="text-xl font-bold text-white mt-8 mb-4">
        Expansión a consultas transaccionales
      </h3>
      <PostHighlight>
        Se espera que la cobertura de AI Overviews alcance el 40-50% de las búsquedas, 
        incluyendo consultas comerciales y transaccionales que hasta ahora estaban menos afectadas.
      </PostHighlight>
      <ul className="list-disc pl-6 space-y-2 mt-4">
        <li><strong>Consultas de compra:</strong> los AI Overviews empezarán a incluir comparativas de producto y recomendaciones</li>
        <li><strong>Búsquedas comerciales:</strong> resúmenes con pros y contras de servicios y productos</li>
        <li><strong>Integración con Shopping:</strong> conexión directa con Google Merchant Center</li>
      </ul>

      <h3 id="personalizacion-ia" className="text-xl font-bold text-white mt-8 mb-4">
        Personalización y búsqueda multimodal
      </h3>
      <p>
        El futuro de los AI Overviews pasa por la <strong>personalización</strong> y la capacidad 
        <strong> multimodal</strong>:
      </p>
      <ul className="list-disc pl-6 space-y-2 mt-4">
        <li><strong>Respuestas personalizadas:</strong> adaptadas al historial, ubicación y preferencias del usuario</li>
        <li><strong>Integración multimedia:</strong> vídeos, infografías e interactivos dentro del resumen</li>
        <li><strong>Convergencia multiplataforma:</strong> funciones similares en Bing, Perplexity y búsquedas sociales</li>
        <li><strong>Búsqueda conversacional avanzada:</strong> diálogos más largos y contextuales con el buscador</li>
      </ul>

      <div className="mt-8 p-6 bg-seo-blue/10 border border-seo-bright/20 rounded-lg">
        <h4 className="text-lg font-bold text-seo-bright mb-3">📋 Checklist: ¿Está tu web preparada para los AI Overviews?</h4>
        <ul className="list-disc pl-6 space-y-2 text-gray-300">
          <li>¿Tu contenido responde preguntas directamente en las primeras líneas?</li>
          <li>¿Tienes clusters de contenido con autoridad temática demostrada?</li>
          <li>¿Implementas Schema markup (FAQ, Article, HowTo)?</li>
          <li>¿Tu contenido incluye datos originales, estadísticas o experiencia real?</li>
          <li>¿Actualizas regularmente con fechas visibles?</li>
          <li>¿Tu web es rápida, móvil-friendly y con buena UX?</li>
          <li>¿Monitorizas si apareces citado en AI Overviews?</li>
        </ul>
      </div>
    </PostSection>
  );
}
